import React from "react";

import { Box, Text, Link } from "src/components/base";

import { ArrowInCircle } from "src/icons";

export default ({ to, title, ...props }) => (
  <Link
    color="link"
    align="center"
    flexDirection="row"
    fontWeight="semibold"
    to={to}
    style={{ textDecoration: "none", lineHeight: 1 }}
    aria-label={title}
    {...props}
  >
    {"Learn\u00a0More"}
    <Box ml={2} mt="1px">
      <ArrowInCircle size={30} color="blue" />
    </Box>
  </Link>
);



// WEBPACK FOOTER //
// ./src/components/LearnMoreLink.js